import { UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { CReqExecutionResultEnum } from "../CReqExecutionResultEnum";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchUserEventsResData } from "./FetchUserEventsResData";

const ENDPOINT = "/userevents/";

export class FetchUserEventsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchUserEventsReqData;

    constructor(payload: FetchUserEventsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchUserEventsResData> {
        let res = await this.executeCommand(this.payload);
        return new FetchUserEventsResData(res);
    }
}

export class FetchUserEventsReqData implements IPaginationFilter {
    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    userEventStartDate: Date = null;
    userEventEndDate: Date = null;
    eventType: UserEventTypeEnum[] = [];
    agentLastMessageDateRange: string[] = [];
    installationNames: string[] = null;
    userNames: string[] = null;
    involvedUserNames: string[] = null;
    responseTypes: CReqExecutionResultEnum[] = [];
}
